import { combineReducers } from '@fullstory/redux-util/utils/combineReducers';
import { createRequestReducer } from '@fullstory/redux-util';
import { ImpactTypes } from '../types';
import { RevenueEvent } from '@fullstory/proto/fs/services/webber/conversions';

const revenueEvent = createRequestReducer<RevenueEvent>()(
  ImpactTypes.RevenueEventRequest,
  ImpactTypes.RevenueEventSuccess,
  ImpactTypes.RevenueEventFailure,
);

const averageOrderValue = createRequestReducer<number>()(
  ImpactTypes.FetchAverageOrderValueRequest,
  ImpactTypes.FetchAverageOrderValueSuccess,
  ImpactTypes.FetchAverageOrderValueFailure,
);

export const totalRevenue = createRequestReducer<number>()(
  ImpactTypes.FetchTotalRevenueRequest,
  ImpactTypes.FetchTotalRevenueSuccess,
  ImpactTypes.FetchTotalRevenueFailure,
);

type RevenueAttributionState = {
  revenueEvent: ReturnType<typeof revenueEvent>;
  averageOrderValue: ReturnType<typeof averageOrderValue>;
  totalRevenue: ReturnType<typeof totalRevenue>;
};

export const revenueAttribution = combineReducers<RevenueAttributionState>({
  revenueEvent,
  averageOrderValue,
  totalRevenue,
});
